import {useState, useCallback, useEffect, useContext} from 'react';
import {Routes, Route, useLocation, Navigate} from 'react-router-dom';
import {UserContext} from './contexts/UserContext';
// import { getAnalytics } from "firebase/analytics";

//Frontend
import Home from "./frontend/pages/Home";
import Sites from "./frontend/pages/Sites";

//Authentication
// import Registration from "./backend/pages/Registration";
import Login from "./auth/pages/Login";

//Backend
import AdminDashboard from './backend/pages/Dashboard';
// import AdminSitiList from './backend/pages/SitiList';
// import AdminSitiSingle from './backend/pages/SitiSingle';
// import AdminMacrolottiList from './backend/pages/MacrolottiList';
// import AdminMacrolottiSingle from './backend/pages/MacrolottiSingle';
// import AdminSubareeList from './backend/pages/SubareeList';
// import AdminSubareeSingle from './backend/pages/SubareeSingle';
import AdminRapportiList from './backend/pages/RapportiList';
import AdminUsersList from './backend/pages/UsersList';
import AdminUsersSingle from './backend/pages/UsersSingle';

//Map
import Map from './map/Map';

//404
import NotFound from "./frontend/pages/NotFound";

import {BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_XS, LAYOUT_LG, LAYOUT_MD, LAYOUT_SM, LAYOUT_XS } from './config';

const RequireAuth = ({children}) => {
  const {user} = useContext(UserContext);
  let location = useLocation();
  if (!user) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }
  return (<>{children}</>);
}

const RequireAdminAuth = ({children}) => {
  const {user} = useContext(UserContext);
  let location = useLocation();
  if (user && user.Level !== "Editor" && user.Level !== "Publisher" && user.Level !== "Admin") {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return (<>{children}</>);
}

const App = () => {
  const [resizeListener, setResizeListener] = useState(false);
  const [layout, setLayout] = useState(null);

  // useEffect(() => {
  //   AnalyticsService.getUrl(src).then((response) => {
  //     if(response.success){
  //       setUrl(response.url);
  //     }else{
  //       console.log(response.error);
  //     }
  //   });
  // }, []);

  const handleResize = useCallback(() => {
    setLayout(window.innerWidth <= BREAKPOINT_XS ? LAYOUT_XS : (window.innerWidth <= BREAKPOINT_SM ? LAYOUT_SM : (window.innerWidth <= BREAKPOINT_MD ? LAYOUT_MD : LAYOUT_LG)));
  }, []);

  useEffect(() => {
    if(!resizeListener){
      setResizeListener(true);
      window.addEventListener("resize", handleResize, false);
      handleResize();
    }
  }, [handleResize, resizeListener]);

  return (
    <Routes>

      {/*301*/}
      <Route exact path='/' element={<RequireAuth><Navigate to={"/it"} /></RequireAuth>} />

      {/*Frontend*/}
      <Route exact path='/:lang/' element={<RequireAuth><Home layout={layout} /></RequireAuth>} />
      <Route exact path='/:lang/siti/:slug' element={<RequireAuth><Sites layout={layout} /></RequireAuth>} />
      {/*
      <Route exact path='/:lang/horses' element={<HorsesList layout={layout} />} />
      <Route exact path='/:lang/horses/:slug' element={<HorsesSingle layout={layout} />} />
      */}

      {/*Backend*/}
      <Route exact path='/admin' element={<RequireAdminAuth><AdminDashboard layout={layout} /></RequireAdminAuth>} />
      {/* <Route exact path='/admin/siti' element={<RequireAuth><AdminSitiList layout={layout} /></RequireAuth>} />
      <Route exact path="/admin/siti/:slug" element={<RequireAuth><AdminSitiSingle layout={layout} /></RequireAuth>} />
      <Route exact path='/admin/macrolotti' element={<RequireAuth><AdminMacrolottiList layout={layout} /></RequireAuth>} />
      <Route exact path="/admin/macrolotti/:slug" element={<RequireAuth><AdminMacrolottiSingle layout={layout} /></RequireAuth>} />
      <Route exact path='/admin/subaree' element={<RequireAuth><AdminSubareeList layout={layout} /></RequireAuth>} />
      <Route exact path="/admin/subaree/:slug" element={<RequireAuth><AdminSubareeSingle layout={layout} /></RequireAuth>} /> */}
      <Route exact path='/admin/rapporti-prova' element={<RequireAuth><AdminRapportiList layout={layout} /></RequireAuth>} />
      <Route exact path='/admin/users' element={<RequireAuth><AdminUsersList layout={layout} /></RequireAuth>} />
      <Route exact path="/admin/users/:slug" element={<RequireAuth><AdminUsersSingle layout={layout} /></RequireAuth>} />

      {/*Authentication*/}
      <Route exact path='/auth' element={<Navigate to="/auth/login" />}/>
      <Route exact path='/auth/login' element={<Login />} />
    
      {/*Test Map*/}
      <Route exact path='/map' element={<RequireAdminAuth><Map layout={layout} /></RequireAdminAuth>} />
    
      {/*404*/}
      <Route path='*' element={<NotFound layout={layout} />} />
    </Routes>
  );
}

export default App;
